import { Uppy } from '@uppy/core';
import Tus from '@uppy/tus';
import { kebabCase } from 'lodash-es';
import { nanoid } from 'nanoid/non-secure';
import type { RespondedType } from '@/models/response';
import type { UppyFileMeta } from '@/models/uploadable';
import { insertAuthorization } from '@/utils/fetcher';

export function createUppy() {
  const uppy = new Uppy<UppyFileMeta, RespondedType>();

  uppy.setOptions({
    autoProceed: false,
    restrictions: {
      maxNumberOfFiles: 1,
    },
  });
  uppy.use(Tus, {
    id: 'tus-upload',
    chunkSize: 1024 * 1024 * 6,
    removeFingerprintOnSuccess: true,
    onShouldRetry: () => false,
    headers: () => {
      const headers = Object.fromEntries(
        Object.entries(insertAuthorization(true)).map(([key, value]) => [kebabCase(key), value?.toString() ?? '']),
      );

      headers['File-Id'] = nanoid(24);

      return headers;
    },
    allowedMetaFields: ['FileName', 'FileType', 'UID', 'ChatSessionID'],
  });

  return uppy;
}
